export class User {

    public firstname: string;
    public lastname: string;
    public email: string;
    public telephone: string;

    public static createMany(data: Partial<User>[]): User[] {
        let users: User[] = [];
        for (let item of data) {
            users.push(User.createOne(item));
        }
        return users;
    }

    public static createOne(data: Partial<User>): User {
        let user = new User();
        user.fill(data);
        return user;
    }

    public fill(data: Partial<User>) {
        if (!data) return;

        this.firstname = data.firstname || null;
        this.lastname = data.lastname || null;
        this.email = data.email || null;
        this.telephone = data.telephone || null;
    }

}



// WEBPACK FOOTER //
// ./src/models/user.ts